module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc17-b5b2a00e61bb78082538295d5908e214.jpg";